<template lang="pug">
.general-form
    AddressSearch(v-if="addressRequired")
    AgeOfHome(v-if="addressRequired ? isAddressValid : true")
    NumberOfStoreys(v-if="addressRequired ? isAddressValid : true")
    HouseType(v-if="storeys != -1 && filteredHouseTypes.length" :houseTypes="filteredHouseTypes")
    HouseTypology(v-if="storeys != -1 && houseTypeSelected != null")
    TermsAgreement(v-if="storeys != -1 && houseTypeSelected != null && houseTypologySelected != null")
</template>
<script lang="ts">
import { defineComponent } from "vue";
import AgeOfHome from "@/components/forms/questions/general/AgeOfHome.vue";
import NumberOfStoreys from "@/components/forms/questions/general/NumberOfStoreys.vue";
import HouseType from "@/components/forms/questions/general/HouseType.vue";
import HouseTypology from "@/components/forms/questions/general/HouseTypology.vue";
import TermsAgreement from "@/components/forms/questions/TermsAgreement.vue";
import AddressSearch from "./questions/AddressSearch.vue";
import { storeToRefs } from "pinia";
import { useSelections } from "@/store/selections";
import { useSettings } from "@/store/settings";
import { computed, onMounted } from "vue";

export default defineComponent({
  name: "GeneralForm",
  components: {
    AgeOfHome,
    NumberOfStoreys,
    AddressSearch,
    HouseType,
    HouseTypology,
    TermsAgreement,
  },
  setup() {
    const { settings } = storeToRefs(useSettings());
    const { getHouseTypologies } = useSelections();
    const {
      storeys,
      houseTypeSelected,
      filteredHouseTypes,
      houseTypologySelected,
      addressResult,
    } = storeToRefs(useSelections());

    const addressRequired = computed<boolean>(() => !!settings.value?.autoaddressKey);
    const isAddressValid = computed<boolean>(() => !!addressResult.value);

    onMounted(async () => {
      await getHouseTypologies();
    });
    return {
      storeys,
      houseTypeSelected,
      filteredHouseTypes,
      houseTypologySelected,
      addressRequired,
      isAddressValid,
    };
  },
});
</script>
<style scoped lang="scss">
.general-form {
  display: flex;
  flex-direction: column;
}
</style>
